import type { FaireProductEntity } from "../../entity_types/product";

export const p_q8jecsnm5h: FaireProductEntity = {
  token: "p_q8jecsnm5h",
  type: "product",
  name: "Melati Classic Zero-Alcohol Botanical Spirit (with gift box)",
  brandToken: "b_5p3hx22es9",
  brandName: "Melati Drinks",
  imageUrl:
    "https://cdn.faire.com/fastly/861adfacb7dadc2fd7a0d9e6ac6529933a498460fb290aa9e74b9f04c9ccf455.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e7b2c785852f8109209f6d2b4ff50029fe829a7a76170e069f67fcfd5b08fb78.jpeg",
    "https://cdn.faire.com/fastly/e1bf1e72399f233531056c4f3f0e9c3cb4ed3a1586e1339fe7c409b07e2cad2e.jpeg",
  ],
  priceDollars: 45.73,
  description:
    "Melati Drinks is Asia's First Non-Alcoholic Spirit. Born out of the royal courts of the Far East, we uncovered botanical tonic recipes served since 1293. Travel through the magnificent volcanic highlands of Asia in a bold, delicious and healthy alcohol alternative. Savor uplifting goji berries, aromatic Asian spices and a long dry bitter finish. Let’s raise a glass to your health!\n\nEach bottle directly supports women's future in Indonesia and is ethically made within a circular economy.\n\nHerbaceous, bitter and balanced, Melati Classic is a full-bodied non-alcoholic spirit with a dry finish for red wine lovers. Goji berries, fresh hibiscus and earthy raw cacao are balanced by bitter orange and grounded in warm asian spices. Best enjoyed with tonic water in a wine glass for a sophisticated drink.\n\nThe bottle comes with a beautiful gift box.",
  tags: [],
  msrpDollars: 91.46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:57:55.699Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
